import { styled, SxProps } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid/DataGrid';

const StyledDataGrid = styled(DataGrid)(() => ({
  '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
    borderRight: '2px solid #f0f0f0',
  },
  '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
    borderBottom: '2px solid #f0f0f0',
  },
  '& .MuiTablePagination-select': {
    minHeight: '0px !important',
  },
  '& .MuiDataGrid-row:hover .visible-on-row-hover': {
    display: 'inline-block',
  },
}));

const Component: typeof DataGrid = (props) => {
  const styles: SxProps = {};

  if (props.onCellClick || props.onRowClick) {
    styles['& .MuiDataGrid-row:hover'] = {
      cursor: 'pointer',
    };
  }

  return <StyledDataGrid {...props} sx={styles} />;
};

export default Component;
